module.exports = __webpack_public_path__ + "static/media/no-bank.673ab5eb.png";